import pkg from "../../package.json";

/** App version (semver), sourced once from package.json. */
export const APP_VERSION: string = pkg.version;
